import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { track } from 'meta-pixel';
export function FinalCTA() {
  return <section id="comprar" className="py-24 px-6 bg-warm-50" data-id="element-36">
      <div className="max-w-3xl mx-auto text-center" data-id="element-37">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-38">
          <span className="text-teal-600 font-bold tracking-wider text-sm uppercase mb-6 block" data-id="element-39">
            La Promesa Honesta
          </span>

          <h2 className="text-3xl md:text-4xl font-bold text-warm-900 mb-8 font-display" data-id="element-40">
            No te prometo perfección.
            <br data-id="element-41" />
            Te prometo estructura.
          </h2>

          <div className="text-xl text-warm-900/80 mb-12 space-y-4" data-id="element-42">
            <p data-id="element-43">Y cuando tienes estructura, pasan dos cosas:</p>
            <ol className="list-decimal list-inside space-y-2 font-medium text-warm-900" data-id="element-44">
              <li data-id="element-45">Gastas menos en decisiones impulsivas</li>
              <li data-id="element-46">Comes mejor sin pelear contigo misma</li>
            </ol>
            <p className="pt-4" data-id="element-47">
              Si estás lista para que tu semana deje de depender de tu energía…
              <br data-id="element-48" />
              <span className="font-bold text-teal-600" data-id="element-49">
                este es tu sistema.
              </span>
            </p>
          </div>

          <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl border border-warm-100 max-w-xl mx-auto" data-id="element-50">
            <h3 className="text-2xl font-bold text-warm-900 mb-2 font-display" data-id="element-51">
              Proteína Lista (sin pensar)
            </h3>
            <p className="text-warm-500 mb-4" data-id="element-52">
              Acceso inmediato al PDF + Bonus
            </p>

            <div className="flex items-center justify-center gap-3 mb-8" data-id="element-53">
              <span className="text-2xl text-warm-300 line-through" data-id="element-54">$17</span>
              <span className="text-5xl font-bold text-teal-600" data-id="element-55">$6.39</span>
              <span className="text-warm-400 text-lg" data-id="element-56">USD</span>
            </div>

            <a href="https://www.enfoquebasico.com/cart/46901455716503:1" target="_blank" rel="noopener noreferrer" onClick={() => {
            if (typeof window !== 'undefined' && (window as any).fbq) {
              ;
              (window as any).fbq('track', 'AddToCart', {
                content_name: 'Proteína Lista (sin pensar)',
                content_type: 'product',
                value: 6.39,
                currency: 'USD'
              });
            }
          }} className="w-full py-4 px-8 bg-teal-600 text-white text-xl font-bold rounded-xl hover:bg-teal-700 hover:scale-[1.02] transition-all duration-300 shadow-lg hover:shadow-xl flex items-center justify-center group" data-id="element-57">
              Comprar ahora
              <ArrowRight className="w-6 h-6 ml-2 transition-transform group-hover:translate-x-1" data-id="element-58" />
            </a>

            <p className="mt-4 text-sm text-warm-400" data-id="element-59">
              Pago seguro • Descarga inmediata
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}